import gsap from 'gsap';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';

type MovieTitle = {
  name: string;
  platform: string;
  rating: string;
  src: string;
  active: boolean;
};

@Component({
  selector: 'app-c08-browse-titles-slider',
  templateUrl: './c08-browse-titles-slider.component.html',
  styleUrls: ['./c08-browse-titles-slider.component.scss'],
})
export class C08BrowseTitlesSliderComponent implements AfterViewInit {
  @ViewChild('slider') sliderElement: ElementRef;
  @ViewChild('c08BrowseTitlesRef') C08sliderContainer: ElementRef;
  @Output() sliderHeight = new EventEmitter<number>();

  private VISIBLE_MOVIE_AMOUNT = 4;
  public activeMovieDescription;
  private _isActive: boolean;
  private _activeIndex: number;

  @Input() movieTiles: Array<MovieTitle>;
  @Input() sliderTitle: string;
  @Input() set isActive(value: boolean) {
    this._isActive = value;
    this.updateAria();
  }
  @Input() set activeIndex(value: number | null) {
    const movementLimit = this.movieTiles.length - this.VISIBLE_MOVIE_AMOUNT;
    if (value !== null && value <= movementLimit && this.sliderElement) {
      gsap.to(this.sliderElement.nativeElement, {
        translateX: -22.8 * value + '%',
      });
    }
    this._activeIndex = value;
    this.updateAria();
  }

  updateAria() {
    if (this._isActive && this._activeIndex >= 0 && this.movieTiles.length) {
      const currentMovie = this.movieTiles[this._activeIndex];
      if (currentMovie)
        this.activeMovieDescription = `${currentMovie.name}, ${currentMovie.platform}`;
    }
  }

  ngAfterViewInit(): void {
    this.sliderHeight.emit(this.C08sliderContainer.nativeElement.getBoundingClientRect().height);
  }
}
